import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import PrintableContractAppendix from '../printable/PrintableContractAppendix'; // Correct path
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Define the expected structure of the fetched appendix data
// (Should match the structure returned by getAppendixDataForPrint)
interface AppendixData {
  contract: {
    contractNumber: string;
    startDate: Date | string;
  };
  client: {
    name: string;
    director?: string | null;
  };
  appendixNumber?: string;
  appendixDate?: Date | string;
  items: Array<{
    structureCode: string;
    structureType: string;
    location: string;
    startDate: Date | string;
    endDate: Date | string;
    price: number;
    total: number;
  }>;
  totalSum: number;
  paymentTerms?: string | null;
}

const ContractAppendixPrintPage: React.FC = () => {
  // The route uses :id which corresponds to the contract ID based on current setup
  const { id: contractId } = useParams<{ id: string }>();
  const [appendixData, setAppendixData] = useState<AppendixData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAppendixData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Use the new backend endpoint for appendix print data
        const response = await axios.get<AppendixData>(`/contracts/${contractId}/appendix-print-data`);
        setAppendixData(response.data);
        // Attempt to trigger print dialog after data is loaded
        setTimeout(() => {
          // window.print();
        }, 500); // Small delay
      } catch (err: any) {
        console.error('Error fetching appendix data for printing:', err);
        setError(err.response?.data?.message || 'Не удалось загрузить данные приложения для печати.');
      } finally {
        setLoading(false);
      }
    };

    if (contractId) {
      fetchAppendixData();
    } else {
      setError('ID договора для приложения не найден.');
      setLoading(false);
    }
  }, [contractId]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="printable-container error-message">Ошибка: {error}</div>;
  }

  if (!appendixData) {
    return <div className="printable-container">Данные приложения для печати не найдены.</div>;
  }

  // Render the printable component with the fetched data
  return <PrintableContractAppendix appendixData={appendixData} />;
};

export default ContractAppendixPrintPage;
